import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { featuredProjects } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function FeaturedProjects() {
  const navigate = useNavigate();

  return (
    <section id="spaces" className="bg-[var(--cream-2)]" style={{ backgroundColor: "var(--cream-2)" }}>
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <Reveal className="mb-16 md:mb-20 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <p className="font-sans-ui tracking-wide-2 text-[0.66rem] uppercase mb-5" style={{ color: "var(--teal)" }}>
              Spaces we design &amp; build
            </p>
            <h2 className="font-serif-display text-[2.4rem] md:text-[3.4rem] leading-[1.05] font-300 text-[var(--navy)]" style={{ color: "var(--navy)" }}>
              One partner, from<br />concept to completion
            </h2>
          </div>
          <button onClick={() => { navigate("/projects"); window.scrollTo({ top: 0 }); }} className="btn-line btn-navy self-start" style={{ color: "var(--navy)" }}>
            All projects
          </button>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {featuredProjects.map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 120}>
              <button
                onClick={() => { navigate("/projects"); window.scrollTo({ top: 0 }); }}
                className="group block text-left w-full"
              >
                <div className="img-zoom relative aspect-[4/3]">
                  <img src={p.image} alt={p.title} className="h-full w-full object-cover" />
                  <div className="absolute inset-0 transition-opacity duration-500 opacity-0 group-hover:opacity-100" style={{ background: "linear-gradient(180deg, rgba(14,35,56,0) 40%, rgba(14,35,56,0.55) 100%)" }} />
                  <div className="absolute top-5 right-5 h-11 w-11 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0" style={{ backgroundColor: "var(--cream)" }}>
                    <ArrowUpRight size={18} strokeWidth={1.5} style={{ color: "var(--navy)" }} />
                  </div>
                </div>
                <div className="pt-5 flex items-baseline justify-between">
                  <div>
                    <h3 className="font-serif-display text-2xl md:text-3xl text-[var(--navy)]" style={{ color: "var(--navy)" }}>{p.title}</h3>
                    <p className="mt-1 text-[var(--muted)] text-sm" style={{ color: "var(--muted)" }}>{p.subtitle}</p>
                  </div>
                  <span className="font-sans-ui tracking-wide-3 text-[0.6rem] uppercase" style={{ color: "var(--teal)" }}>{p.studio}</span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
